module.exports = __webpack_public_path__ + "static/media/kqyuan.0bf3daf1.jpg";